import { observable, runInAction } from 'mobx';
import { IConsent } from 'telia-front-react';

class CookieConsentStore {
  @observable accessor isCookiebotEnabled: boolean;
  @observable accessor cookieConsents: IConsent;

  constructor(initialCookieConsents: IConsent) {
    this.evaluateCookiebotEnabled();
    this.setListeners();
    this.setCookieConsents(initialCookieConsents);
  }

  public evaluateCookiebotEnabled = () => {
    runInAction(() => {
      const isCookiebotLoaded = !!window.CookieControl?.Dialog || window.Cookiebot?.consented || window.Cookiebot?.declined;
      this.isCookiebotEnabled = isCookiebotLoaded || !this.isCookiebotBlocked();
    });
  };

  public static isPreferencesCookiesEnabled = (): boolean => {
    return window.Cookiebot?.consent?.preferences;
  };

  public static isStatisticsCookiesEnabled = (): boolean => {
    return window.Cookiebot?.consent?.statistics;
  };

  private isCookiebotBlocked = () => {
    return !!window.Cookiebot && !window.CookieControl;
  };

  private setListeners = () => {
    window.addEventListener('CookiebotOnLoad', () => {
      this.evaluateCookiebotEnabled();
      this.setCookieConsents();
    });
    window.addEventListener('CookiebotOnDialogInit', () => this.evaluateCookiebotEnabled());
  };

  private setCookieConsents = (initialCookieConsents?: IConsent) => {
    runInAction(() => {
      const cookieConsents = window.Cookiebot?.consent || initialCookieConsents || { necessary: true };
      this.changeTeliaRumPermissions(cookieConsents);
      this.cookieConsents = cookieConsents;
    });
  };

  private changeTeliaRumPermissions(cookieConsents: IConsent) {
    if (window.TeliaRum) {
      window.TeliaRum.setCookiesAllowed(cookieConsents.statistics);
    }
  }
}

export default CookieConsentStore;
